import Image from "next/image";
import Link from "next/link";
import { CalendarDays, Tag, Ticket } from "lucide-react";
import { Campaign } from "@/app/lib/features/campaign/campaign.types";
import { trackCampaignView } from "@/app/lib/tracking/interactions";

interface CampaignCardProps {
  campaign: Campaign;
}

const CampaignCard = ({ campaign }: CampaignCardProps) => {
  const hasAmount =
    campaign.amount_formatted && campaign.amount_formatted !== "0₺";

  return (
    <Link
      href={`/kampanya/${campaign.code}`}
      onClick={() => trackCampaignView(campaign.id)}
      className="group flex flex-col sm:flex-row items-start sm:items-center gap-4 bg-white border border-gray-200 rounded-xl p-4 sm:p-5 hover:shadow-md hover:border-gray-300 transition-all duration-200"
    >
      {/* Görsel veya ikon */}
      <div className="relative w-14 h-14 shrink-0">
        {campaign.image ? (
          <Image
            src={campaign.image}
            alt={campaign.title}
            fill
            className="object-cover rounded-lg border border-gray-100"
            sizes="56px"
          />
        ) : (
          <div className="w-14 h-14 rounded-lg bg-gray-900 flex items-center justify-center">
            <Ticket size={24} className="text-white" />
          </div>
        )}
      </div>

      {/* İçerik */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="font-semibold text-gray-900 text-sm leading-snug group-hover:text-gray-700 transition-colors">
            {campaign.title}
          </h3>
          {hasAmount && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-xs font-medium shrink-0">
              <Tag size={10} />
              {campaign.amount_formatted}
            </span>
          )}
        </div>

        {campaign.sub_title && (
          <p className="text-xs text-gray-500 mt-0.5 line-clamp-1">
            {campaign.sub_title}
          </p>
        )}

        <div className="mt-2 inline-flex items-center gap-1.5 px-2 py-0.5 rounded bg-gray-50 border border-dashed border-gray-300 text-xs text-gray-500 font-mono tracking-wide">
          <Ticket size={10} />
          {campaign.code}
        </div>
      </div>

      {/* Bitiş tarihi */}
      {campaign.end_date_text && (
        <div className="flex items-center gap-1.5 text-xs text-gray-500 shrink-0 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 self-start sm:self-auto">
          <CalendarDays size={12} className="shrink-0" />
          <span>{campaign.end_date_text}</span>
        </div>
      )}
    </Link>
  );
};

export default CampaignCard;